<template>
  <div class="config-tab tab-content">
    <div class="content">
      <v-skeleton-loader type="article" />
    </div>
  </div>
</template>

<script>
/**
 * @fileoverview Loading tab
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "LoadingTab",
};
</script>

<style lang="scss" scoped>
.config-tab {
  display: flex;
  height: 100%;
}
.content {
  width: 100%;
  margin: $qvo-spacing-24;
}

nav {
  background: $qvo-color-blue-100;
  padding: $qvo-spacing-24;
  padding-top: 0;
  position: sticky;
  top: $qvo-spacing-24;
}
.v-skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>